module.exports = __webpack_public_path__ + "img/sz.b93f09f0.png";